export var getExtensionEntryPoint = function getExtensionEntryPoint(extension, entryPoint) {
  var _extension$properties;
  var defaultEntryPoint = extension.properties.resource;
  var alternativeEntryPoint = entryPoint && ((_extension$properties = extension.properties[entryPoint]) === null || _extension$properties === void 0 ? void 0 : _extension$properties.resource);
  return alternativeEntryPoint || defaultEntryPoint;
};